import React, { Component,useState } from 'react';
import ScreenContainer from '../ui/ScreenContainer';
import BasicPageComponent from '../BasicPageComponent';
import EditGrid from '../ui/EditGrid/EditGrid';
import * as apiDashBoardService from './apiRequestService';
import * as Actions from '../../redux/actions';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { GridColumns } from './GridColumns';

class ProcessTemplate extends Component {
 

  constructor(props) {
    super(props);
    this.gridFunc = React.createRef();
    this.state = {
      gridData: [],
      // gridFunc:null,
      gridColumns : GridColumns,
      CRUDServices:{
        Create:apiDashBoardService.createProcessTemplate,
        Update:apiDashBoardService.updateProcessTemplate,
        Delete:apiDashBoardService.deleteProcessTemplateById}
    };
  }

//  async refreshList(){
//     let response= await apiDashBoardService.getProcessTemplates()
//     //this.setState({ gridData: response.data});
//     this.gridFunc.state.gridRows= response.data;
//     this.gridFunc.state.gridColumns= this.state.gridColumns;
//     this.gridFunc.state.columnVisibilityModel= {id:false,recordStatus:false,internalSigners:false,externalSigners:false};

//     this.gridFunc.setState(this.gridFunc.state)
        
//   }

  refreshList(){
    apiDashBoardService.getProcessTemplates()
    .then((response) => {
      this.gridFunc.state.gridRows= response.data;
      this.gridFunc.state.gridColumns= this.state.gridColumns;
      this.gridFunc.state.columnVisibilityModel= {id:false,recordStatus:false,internalSigners:false,externalSigners:false};
  
      this.gridFunc.setState(this.gridFunc.state)
    })
    .catch((exception) => {
      this.props.actions.setNotification("Süreç şablon bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
      console.log('getProcessTemplates exception: ' + JSON.stringify(exception));
    });
    
  }

  componentDidMount() {
    this.refreshList();
  }

  closeEditPage(ele) {
    this.refreshList();
  }


  render() {
    const { CRUDServices } = this.state;

    return (
      <div>
        <div style = {{display: 'flex',
          flexDirection: 'column'}}>
          <BasicPageComponent
            title='PROCESS TEMPLATE'
            description='Süreç Şablonları Tanımlama Ekranı'
            children = {
              <ScreenContainer>
            {/* <div><ChildGrid {...this.props}/></div> */}
            <EditGrid ref={instance => { this.gridFunc = instance; }} dialogTitle="Süreç Şablonu" gridHeight={400} {...this.props} CRUD={CRUDServices} 
            LoadData={(e) => this.closeEditPage(e)}/>
            </ScreenContainer>
            }
          />       
        </div>
        <div>
            {/* <Button
              // disabled={loading}
              text = 'Kaydet'
              // type = "submit"
              onClick={this.saveButtonClick}
            >
            </Button>
          <Button
              // disabled={loading}
              text = 'İptal'
              onClick={this.cancelButtonClick}
            >
            </Button> */}
        </div>
      </div>
    );
  }
}


const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
});

export default compose(
  connect(
    null,
    mapDispatchToProps
  )
)(ProcessTemplate);